var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComponent116(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.999,
    height: 30.025,
    viewBox: "0 0 31.999 30.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_116_2",
    "data-name": "Component 116 \\u2013 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M-715.756,1307.8a6.519,6.519,0,0,0-7.588-5.068,6.483,6.483,0,0,0-5.314,5.707,6.4,6.4,0,0,0,.98,4.233q1.016,1.6,2.037,3.19,1.437,2.247,2.876,4.492a.7.7,0,0,0,.716.372.767.767,0,0,0,.554-.432q2.421-3.786,4.844-7.572a6.863,6.863,0,0,0,1.082-3.561C-715.63,1308.709-715.663,1308.249-715.756,1307.8Zm-6.392,5.677a4.3,4.3,0,0,1-4.315-4.321,4.316,4.316,0,0,1,4.3-4.3,4.323,4.323,0,0,1,4.328,4.317A4.312,4.312,0,0,1-722.148,1313.479Z",
    transform: "translate(728.7 -1290.709)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M-725.075,1309.162a2.92,2.92,0,0,0,2.927,2.931,2.925,2.925,0,0,0,2.926-2.919,2.932,2.932,0,0,0-2.936-2.928A2.928,2.928,0,0,0-725.075,1309.162Z",
    transform: "translate(728.7 -1290.709)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M-697.1,1293.938a4.065,4.065,0,0,0-4.731-3.16,4.042,4.042,0,0,0-3.313,3.558,3.987,3.987,0,0,0,.611,2.639q.633,1,1.27,1.989.9,1.4,1.793,2.8a.436.436,0,0,0,.446.232.478.478,0,0,0,.346-.269q1.509-2.361,3.019-4.721a4.266,4.266,0,0,0,.675-2.22C-697.025,1294.5-697.045,1294.216-697.1,1293.938Zm-3.985,3.539a2.683,2.683,0,0,1-2.69-2.694,2.689,2.689,0,0,1,2.681-2.68,2.694,2.694,0,0,1,2.7,2.691A2.688,2.688,0,0,1-701.088,1297.477Z",
    transform: "translate(728.7 -1290.709)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M-702.067,1302.633c-1.206.693-2.382,1.362-3.551,2.047a1.024,1.024,0,0,0-.4.4.631.631,0,0,0,.519.923c.4.03.8.018,1.2.019q3.183.01,6.368.017a1.1,1.1,0,0,1,1.2.829,1.39,1.39,0,0,1-.724,1.516q-4.592,2.558-9.185,5.108l-11.889,6.6c-.1.057-.209.1-.319.154.534-.745,1.111-1.435,1.567-2.215.653-1.116,1.225-2.3,1.814-3.457a.978.978,0,0,1,.443-.487q4.652-2.325,9.295-4.671c.267-.134.51-.28.522-.666a.6.6,0,0,0-.508-.676,2.97,2.97,0,0,0-.389-.014q-2.583,0-5.166,0a1.7,1.7,0,0,1-.45-.047.917.917,0,0,1-.639-.752.779.779,0,0,1,.333-.843,6.407,6.407,0,0,1,.815-.523c2.647-1.411,5.3-2.812,7.945-4.226a.294.294,0,0,1,.441.091C-702.6,1302.048-702.345,1302.316-702.067,1302.633Z",
    transform: "translate(728.7 -1290.709)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M-702.72,1294.786a1.627,1.627,0,0,0,1.632,1.633,1.63,1.63,0,0,0,1.631-1.627,1.635,1.635,0,0,0-1.637-1.632A1.633,1.633,0,0,0-702.72,1294.786Z",
    transform: "translate(728.7 -1290.709)",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent116);
export default __webpack_public_path__ + "static/media/Component116.1e5ba039.svg";
export { ForwardRef as ReactComponent };